import { createErrorLink } from "shared-ui/utils/createErrorLink";
import { createDedupedRefresh } from "shared-ui/utils/createDedupedRefresh";
import { refreshWithAccessTokenCookie } from "../utils/tokens";

export const errorLink = createErrorLink({
  dedupedRefresh: createDedupedRefresh({
    refresh: refreshWithAccessTokenCookie,
  }),
});
